<div class="prompt-research-container">
  <!-- Prompt Research Header -->
  <div class="active-tab-info">
    <h2>Prompt Creation</h2>
    <div class="header-actions">
      <button mat-button color="primary" (click)="openNewResearchDialog()">
        <mat-icon>add</mat-icon>
        New Prompt Creation
      </button>
      <button mat-icon-button [matMenuTriggerFor]="tabMenu" matTooltip="Open tab menu" class="mobile-tab-menu">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </div>

  <!-- Tab Selection Menu -->
  <mat-menu #tabMenu="matMenu">
    @for (tab of getVisibleTabs(); track tab.id) {
      @if (tab.subTabs && tab.subTabs.length > 0) {
        <!-- Parent Tab with Sub-menu -->
        <button mat-menu-item [matMenuTriggerFor]="auditSubMenu">
          <mat-icon>{{ tab.icon }}</mat-icon>
          <span>{{ tab.name }}</span>
          <mat-icon>arrow_right</mat-icon>
        </button>
      } @else {
        <button mat-menu-item (click)="openTab(tab.id)">
          <mat-icon>{{ tab.icon }}</mat-icon>
          <span>{{ tab.name }}</span>
        </button>
      }
    }
  </mat-menu>
  
  <!-- Sub-menu for Audit tab -->
  <mat-menu #auditSubMenu="matMenu">
    @for (subTab of getSubTabs('audit'); track subTab.id) {
      <button mat-menu-item (click)="openSubTab('audit', subTab.id)">
        <mat-icon>{{ subTab.icon }}</mat-icon>
        <span>{{ subTab.name }}</span>
      </button>
    }
  </mat-menu>

  <!-- Loading State -->
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading research history...</p>
    </div>
  }

  <!-- Error State -->
  @if (error && !loading) {
    <div class="error-container">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <p class="error-message">{{ error }}</p>
      <button mat-button color="primary" (click)="loadResearches()">Retry</button>
    </div>
  }

  <!-- Research Table -->
  @if (!loading && !error) {
    <div class="table-container">
      @if (researches.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-icon">search_off</mat-icon>
          <h3>No Research History</h3>
          <p>Start by creating your first prompt research to discover AI prompts related to your brand.</p>
        </div>
      } @else {
        <table mat-table [dataSource]="researches" class="research-table">
          <!-- Research Name Column -->
          <ng-container matColumnDef="research_name">
            <th mat-header-cell *matHeaderCellDef>Research Name</th>
            <td mat-cell *matCellDef="let research" class="research-name-cell">
              <div class="research-name-content">
                <strong>{{ research.research_name }}</strong>
                <span class="research-type-badge" [attr.data-type]="research.research_type">
                  {{ research.research_type === 'seo_keywords' ? 'SEO Keywords' : 
                     research.research_type === 'url_analysis' ? 'URL Analysis' : 
                     'Brand Brainstorm' }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Date Created Column -->
          <ng-container matColumnDef="created_at">
            <th mat-header-cell *matHeaderCellDef>Date Created</th>
            <td mat-cell *matCellDef="let research">{{ formatDate(research.created_at) }}</td>
          </ng-container>

          <!-- Number of Prompts Column -->
          <ng-container matColumnDef="prompt_count">
            <th mat-header-cell *matHeaderCellDef>Prompts</th>
            <td mat-cell *matCellDef="let research">
              <span class="prompt-count">{{ research.prompt_count }}</span>
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let research" class="actions-cell">
              <button mat-icon-button color="accent" (click)="exportResearch(research, $event)" 
                      matTooltip="Export to CSV" matTooltipPosition="above">
                <mat-icon>download</mat-icon>
              </button>
              <button mat-icon-button class="delete-research-btn" (click)="deleteResearch(research, $event)" 
                      matTooltip="Delete this research (all prompts)" matTooltipPosition="above"
                      [disabled]="deletingResearchId === research.id">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['research_name', 'created_at', 'prompt_count', 'actions']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['research_name', 'created_at', 'prompt_count', 'actions']" 
              (click)="onRowClick(row, $event)" class="research-row"></tr>
        </table>
      }
    </div>
  }
</div>
